<template>
  <ul class="px-[10px]">
    <ChainCard
      v-for="value in chains.items"
      :key="value.id"
      :chain="value" />
  </ul>
</template>

<script>
import ChainCard from '@/components/common/ChainCard.vue';

export default {
  name: 'AllChainsList',
  components: {
    ChainCard,
  },
  props: {
    chains: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
